<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'


export default {
  page: {
    title: 'Templates List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Templates',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Templates',
          href: '/',
          active: true,
        },
        {
          text: 'List',
          active: true,
        },
      ],

    }
  },
  computed: {},
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Resultado Final</h4>
            
            <p class="text-muted font-13 mb-4"></p>
            <div class="row">
              <div class="mb-md-2 col-md-12">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
